import {
    createElementVNode as _$ce,
    createUnknownComponentVNode as _$cc,
} from 'intact';
import {XMarkdown, Button} from 'kpc';


export default function($props, $blocks, $__proto__) {
    $blocks || ($blocks = {});
    $props || ($props = {});
    var $this = this;
    
    return _$ce(2, 'div', [
        _$ce(2, 'div', (
            _$cc(Button, {
                'type': 'primary',
                'ev-click': this.restartTyping,
                'children': '重新开始打字'
            })
        ), 2, 'xmarkdown-demo-tag-renderers-actions'),
        _$cc(XMarkdown, {
            'allowHtml': true,
            'typing': this.get('typing'),
            'content': this.get('content'),
            'sanitizeOptions': this.get('sanitizeOptions'),
            'tagAttrs': this.getTagAttrs(),
            'tagRenderers': this.getTagRenderers()
        })
    ], 4, 'xmarkdown-demo-tag-renderers');
};